<template>
    <div>
        <a-space class="address_box" :size="10">
            <a-select v-model:value="provinceId" @change="getCityList">
                <a-select-option :value="0">请选择省份</a-select-option>
                <a-select-option v-for="province in provinceList" :key="'province' + province.id" :value="parseInt(province.id)">{{province.fullname}}</a-select-option>
            </a-select>
            <a-select v-show="cityList.length > 0" v-model:value="cityId" @change="getDistrictList">
                <a-select-option :value="0">请选择城市</a-select-option>
                <a-select-option v-for="city in cityList" :key="'city' + city.id" :value="parseInt(city.id)">{{city.fullname}}</a-select-option>
            </a-select>
            <a-select v-show="districtList.length > 0" v-model:value="districtId" @change="getTownList">
                <a-select-option :value="0">请选择地区</a-select-option>
                <a-select-option v-for="district in districtList" :key="'district' + district.id" :value="parseInt(district.id)">{{district.fullname}}</a-select-option>
            </a-select>
            <a-select v-show="townList.length > 0" v-model:value="townId" @change="changeRegion">
                <a-select-option :value="0">请选择乡镇</a-select-option>
                <a-select-option v-for="town in townList" :key="'town' + town.id" :value="parseInt(town.id)">{{town.fullname}}</a-select-option>
            </a-select>
        </a-space>
        <div v-show="isDisplayError" :class="[isShowError ? 'has_error' : 'no_error']">
            <p class="text_error">请选择所在地区</p>
        </div>
    </div>
</template>

<script>
export default {
    name: 'SelectAddress',
    props: {
        region: {
            type: Object,
            required: false,
            default () {
                return {
                    province_id: 0,
                    city_id: 0,
                    district_id: 0,
                    town_id: 0
                }
            },
        },
        showTown: {
            type: Boolean,
            required: false,
            default: true
        },
    },
    data () {
        return {
            isShowError: false,
            isDisplayError: false,
            provinceList: [],
            cityList: [],
            districtList: [],
            townList: [],
            isAuto: true,
            provinceId: 0,
            cityId: 0,
            districtId: 0,
            townId: 0,
            areaInfo: {
                provinceName: '',
                cityName: '',
                districtName: ''
            }
        }
    },
    created () {
        this.getProvinceList();
    },
    methods: {
        changeRegion(){
            var province_id = this.provinceId;
            var city_id = parseInt(this.cityId);
            var district_id = this.districtId;
            var town_id = this.townId;
            var province_name = '';
            var city_name = '';
            var district_name = '';
            var town_name = '';
            // console.log('id',province_id,city_id,district_id,town_id);
            if(province_id != 0 && this.provinceList.length > 0){
                for(var i = 0; i < this.provinceList.length; i++){
                    if(this.provinceList[i].id == province_id){
                        province_name = this.provinceList[i].fullname;
                        break;
                    }
                }
            }

            if(city_id != 0 && this.cityList.length > 0){
                for(var i = 0; i < this.cityList.length; i++){
                    if(this.cityList[i].id == city_id){
                        city_name = this.cityList[i].fullname;
                        break;
                    }
                }
            }

            if(district_id != 0 && this.districtList.length > 0){
                for(var i = 0; i < this.districtList.length; i++){
                    if(this.districtList[i].id == district_id){
                        district_name = this.districtList[i].fullname;
                        break;
                    }
                }
            }

            if(town_id != 0 && this.townList.length > 0){
                for(var i = 0; i < this.townList.length; i++){
                    if(this.townList[i].id == town_id){
                        town_name = this.townList[i].fullname;
                        break;
                    }
                }
            }
            this.$emit('change',{
                province_id: province_id,
                city_id: city_id,
                district_id: district_id,
                town_id: town_id,
                province_name: province_name,
                city_name: city_name,
                district_name: district_name,
                town_name: town_name,
            });
        },
        getProvinceList () {
            var _this = this;

            _this.$util.api('/region',{},function(res){
                if(res.code == 10000){
                    _this.provinceList = res.data;
                }
            });
        },
        getCityList () {
            this.cityList = [];
            this.districtList = [];
            this.townList = [];
            this.cityId = 0;
            this.districtId = 0;
            this.townId = 0;

            if(this.provinceId != 0){
                this.$util.api('/region',{
                    id: this.provinceId
                },res => {
                    if(res.code == 10000){
                        this.cityList = res.data;
                    }

                    this.changeRegion();
                });
            }
        },
        getDistrictList () {
            this.districtList = [];
            this.townList = [];
            this.districtId = 0;
            this.townId = 0;

            if(this.cityId != 0){
                this.$util.api('/region',{
                    id: this.cityId
                },res => {
                    if(res.code == 10000){
                        this.districtList = res.data;
                    }

                    this.changeRegion();
                });
            }
        },
        getTownList(){
            this.townList = [];
            this.townId = 0;

            if(this.districtId != 0){
                this.$util.api('/region',{
                    id: this.districtId
                },res => {
                    if(res.code == 10000){
                        this.townList = res.data;
                    }

                    this.changeRegion();
                });
            }
        },
        syncRegion(){
            this.cityList = [];
            this.districtList = [];
            this.townList = [];

            if(this.provinceId != 0){
                this.$util.api('/region',{
                    id: this.provinceId
                },res => {
                    if(res.code == 10000){
                        this.cityList = res.data;

                        if(this.cityId != 0){
                            this.$util.api('/region',{
                                id: this.cityId
                            },res => {
                                if(res.code == 10000){
                                    this.districtList = res.data;

                                    if(this.districtId != 0){
                                        this.$util.api('/region',{
                                            id: this.districtId
                                        },res => {
                                            if(res.code == 10000){
                                                var flag = true;

                                                for(var i = 0; i < res.data.length; i++){
                                                    if(res.data[i].id == this.townId){
                                                        flag = false;
                                                        break;
                                                    }
                                                }

                                                if(flag){
                                                    this.townId = 0;
                                                }

                                                this.townList = res.data;
                                            }
                                        });
                                    }
                                }
                            });
                        }
                    }
                });
            }
        },
        validate (callback) {
            if(this.showTown==true){
                if (this.provinceId == 0 || this.cityId == 0 || this.districtId == 0 || (this.townList.length > 0 && this.townId == 0)) {
                this.isDisplayError = true
                this.isShowError = true

                if (callback) callback(false)
                } else {
                this.isShowError = false
                setTimeout(() => {
                    this.isDisplayError = false
                }, 500)
                if (callback) callback(true)
                }
            }else{
                if (this.provinceId == 0 || this.cityId == 0 || this.districtId == 0 ) {
                this.isDisplayError = true
                this.isShowError = true

                if (callback) callback(false)
                } else {
                this.isShowError = false
                setTimeout(() => {
                    this.isDisplayError = false
                }, 500)
                if (callback) callback(true)
                }
            }
        },
        clearValidate () {
            this.isShowError = false
            this.isDisplayError = false
        }
    },
    watch: {
        region: {
            handler (val) {
                this.provinceId = val.province_id == '' || typeof val.province_id == 'undefined' || val.province_id == 0 ? 0 : parseInt(val.province_id);
                this.cityId = val.city_id == '' || typeof val.city_id == 'undefined' || val.city_id == 0 ? 0 : parseInt(val.city_id);
                this.districtId = val.district_id == '' || typeof val.district_id == 'undefined' || val.district_id == 0 ? 0 : parseInt(val.district_id);
                this.townId = val.town_id == '' || typeof val.town_id == 'undefined' || val.town_id == 0 ? 0 : parseInt(val.town_id);
                this.syncRegion();
                this.changeRegion();
            },
            deep: true,
            immediate: true
        }
    }
}
</script>

<style scoped>
.address_box >>> .ant-select {
    min-width: 125px;
}

.text_error {
    color: #f5222d;
    opacity: 0;
    /* transition: opacity 0.5s; */
    transition: all 1s;
    height: 22px;
    line-height: 22px;
    white-space: nowrap;
}

.has_error .text_error {
    opacity: 1;
    animation: toBottom 0.3s ease-in-out;
}
.no_error .text_error {
    opacity: 0;
    animation: toTop 0.3s ease-in-out;
}

@keyframes toBottom {
    from {
        transform: translateY(-10px);
    }
    to {
        transform: translateY(0);
    }
}

@keyframes toTop {
    from {
        transform: translateY(0);
    }
    to {
        transform: translateY(-10px);
    }
}
</style>



// WEBPACK FOOTER //
// src/components/common/address/SelectAddress.vue